import React, { Component } from "react";
import { Link } from "react-router-dom"; // Utilisé pour créer un lien vers /serviceadd
import firebase from "firebase/compat/app";
import "firebase/database";
import $ from "jquery";
import "datatables.net-bs4";

class ProviderServiceContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      dataTable: null,
    };
  }

  componentDidMount() {
    this.fetchServices();
  }

  fetchServices = () => {
    const { uid, providerId } = this.props;

    // Create a reference to Firebase database
    const servicesRef = firebase.database().ref(`users/${uid}/provider/${providerId}/service`);

    // Listen for changes on the reference
    servicesRef.on("value", (snapshot) => {
      const services = snapshot.val() || [];
      this.setState({ services }, () => {
        this.initDataTable();
      });
    });
  };

  componentWillUnmount() {
    const { uid, providerId } = this.props;
    firebase.database().ref(`users/${uid}/provider/${providerId}/service`).off();
  }

  initDataTable = () => {
    const { services } = this.state;

    if ($.fn.DataTable.isDataTable("#datatable")) {
      this.state.dataTable.destroy();
    }

    const dataTable = $("#datatable").DataTable({
      data: services,
      columns: [
        { data: "serviceName", title: "Nom du service" },
        { data: "contactName", title: "Nom du contact" },
        { data: "contactEmail", title: "Email du contact" },
        { data: "contactPhone", title: "Tel du contact" },
        { data: "invoiceFields", title: "Champs facture" },
      ],
      order: [[0, "asc"]],
      pageLength: 10,
    });

    this.setState({ dataTable });
  };

  render() {
    return (
      <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-subheader   kt-grid__item" id="kt_subheader">
          <div className="kt-container  kt-container--fluid ">
            <div className="kt-subheader__main">
              <h3 className="kt-subheader__title">Services</h3>
            </div>
            <div className="kt-subheader__toolbar">
              <Link
                to={`/${this.props.providerId}/serviceadd`}
                className="btn btn-brand btn-elevate btn-icon-sm"
              >
                <i className="la la-plus"></i>
                Ajouter un service
              </Link>
            </div>
          </div>
        </div>

        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
          <div className="kt-portlet kt-portlet--mobile">
            <div className="kt-portlet__head kt-portlet__head--lg">
              <div className="kt-portlet__head-label">
                <span className="kt-portlet__head-icon">
                  <i className="kt-font-brand fa fa-list-alt"></i>
                </span>
                <h3 className="kt-portlet__head-title">Liste des Services</h3>
              </div>
            </div>
            <div className="kt-portlet__body">
              <table
                className="table table-striped- table-bordered table-hover table-checkable"
                id="datatable"
              >
                <thead>
                  <tr>
                    <th>Nom du service</th>
                    <th>Nom du contact</th>
                    <th>Email du contact</th>
                    <th>Tel du contact</th>
                    <th>Champs facture</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProviderServiceContent;
